import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  IsLoading,
  IsLoaded,
  setLoading,
  MissingTime,
  loadHomeInfo,
} from "../redux/reducers/home.reducer";
import { TimesheetsService } from "../../TimesModule/services/timesheets";
import { selectUserRoles } from "../redux/reducers/auth.reducer";
import { actualUIState } from "../redux/reducers/uiShared.reducer";

export const useHome = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(IsLoading);
  const isLoaded = useSelector(IsLoaded);
  const missingTime = useSelector(MissingTime);
  const { activeUserName } = useSelector(selectUserRoles);
  const {
    todayHours,
    weeklyHours,
    scheduledHours,
    entryReminder,
    isLoadingInfoUser,
  } = useSelector(actualUIState);

  const loadHomePageInfo = useCallback(async () => {
    if (!isLoadingInfoUser && !isLoaded) {
      if (entryReminder) {
        dispatch(setLoading(true));
        const missingTime = await TimesheetsService.getOwnMissingTime();
        dispatch(loadHomeInfo(missingTime));
      } else {
        dispatch(setLoading(false));
      }
    }
  }, [dispatch, isLoadingInfoUser, isLoaded]);

  useEffect(() => {
    loadHomePageInfo();
  }, [loadHomePageInfo]);

  return {
    activeUserName,
    isLoading,
    todayHours,
    weeklyHours,
    scheduledHours,
    entryReminder,
    missingTime,
  };
};
